const AuthorTypeGroup = Object.freeze({
  INDIVIDUAL: 'Individual',
  NON_INDIVIDUAL: 'NonIndividual',
  UNCLASSIFIED: 'Unclassified'
})
export default AuthorTypeGroup
export type AuthorTypeGroupStrings = typeof AuthorTypeGroup[keyof typeof AuthorTypeGroup]
// RESERVE BELOW
